<template>
    <div class="modal fade modal-footer-sticky worli-Bets-Modal profitloss-betslip-modal" id="worliallModal" tabindex="-1"
        aria-labelledby="viewbetsModalLabel" data-bs-backdrop="static" aria-hidden="true">
            <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                        <h5 class="modal-title">{{ $t('bet-slip',"Bet Slip")}}</h5>
                    <button type="button"  class="btn-close" data-bs-dismiss="modal" @click="$emit('close-click')" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="bets-form" v-if="marketBets != null && marketBets.length != 0">
                <div class="account-statement-filter-date">
                    <div class="d-flex w-100">
                        <div class="filter-date-form me-1">
                            <input type="date" v-model="detailFromDate" :min="fromDate" :max="toDate"  class="form-control"/>
                        </div>
                        <div class="filter-date-form">
                            <input type="date" class="form-control" :min="fromDate" :max="toDate" v-model="detailToDate"/>
                        </div>
                    </div>
                    <button @click ="getMarketBetsServiceCall()"  class="btn thm-btn">{{$t('search','Search')}}</button>
                </div>
                <div class="account-statement-tbl">
                    <div class="table-responsive">
                        <table class="table b-table table-striped table-bordered bg-light">
                            <thead class="table-dark">
                                <tr>
                                    <th>Date</th>
                                    <th>Description</th>
                                    <th>P & L</th>
                                    <th>Balance</th>
                                    <th>Remark</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in marketBets" :key="index">
                                    <td> {{ item.event_date ? item.event_date : item.date  }} </td>
                                    <td> {{ item.des }} </td>
                                    <td :class="item.pl > 0 ? 'text-success' : 'text-danger'"> {{ $helper.positive(item.pl) }} </td>
                                    <td> {{ item.balance || '-' }} </td>
                                    <td> {{ item.remark || '-' }} </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div v-if="marketBets != null && marketBets.length == 0">
                <NoDataFound />
            </div>
                </div>
            </div>
        </div>
        </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
export default {
    name: "BetsWinModal",
    props: ['matchDetailId', 'fromDate', 'toDate'],
    emits: ['close-click'],
    components: {
        NoDataFound: defineAsyncComponent(() =>
        import('@/shared/components/no-data/NoDataFound.vue')
        ),
    },
    data() {
        return {
            loading: false,
            marketBets: [],
            profitLossItem: this.$store.getters.profitLossItem,
            detailFromDate: this.fromDate,
            detailToDate: this.toDate,
        };
    },
    mounted() {
        this.profitLossItem = this.$store.getters.profitLossItem;
        this.getMarketBetsServiceCall();
    },
    methods: {
        getMarketBetsServiceCall() {
            let data = {
                "from": this.$dateTime.getcurrentDate('YYYY-MM-DD', this.detailFromDate),
                "to": this.$dateTime.getDateAddedByDays(1, this.detailToDate,'YYYY-MM-DD'),
                "match_id": this.matchDetailId
            };
            this.$apiCall('post', 'GET_PROFIT_LOSS_MATCH_DETAIL', data).then(response => {
                    if (response) {
                        if (response.status == 200) {
                            if (response?.data?.error) {
                                this.$errorToast(response?.data?.error);
                            } else {
                                this.marketBets = response.data.data;
                            }
                        }
                    }
                })
                .catch(error => {
                    if (error) {
                        this.$errorToast(error[0]);
                    }
                });
        }
    },
}
</script>